(function () {
    'use strict';

    var STORAGE_KEY = 'vendorFilter';

    // Single source of truth for every vendor filter option.
    // `vendors` lists the exact Shopify vendor name(s) that option should match.
    // `vendors: null` means "no filter" (search every vendor).
    var VENDOR_OPTIONS = [
        { value: 'bellewood', label: 'Gun Safes', vendors: ['Bellewood Design', 'Bellewood Designs'] },
        { value: 'holster', label: 'Holsters', vendors: ['Powertac', 'Rounded by Concealment Express', 'RoundedGear.com'] },
        { value: 'all', label: 'All Products', vendors: null }
    ];

    var DEFAULT_VENDOR_FILTER = 'bellewood';
    var DEBUG_VENDOR_FILTER = true;
    var DEBOUNCE_MS = 300;
    var MIN_QUERY_LENGTH = 2;
    var moneyFormat = window.theme && (theme.moneyFormatWithCodeForProductsPreference || theme.moneyFormat);

    // Matches a single `vendor:"..."` clause, an optional leading `-`, and
    // any number of `OR vendor:"..."` clauses chained after it, with or
    // without wrapping parentheses. This lets us strip whichever vendor
    // filter clause buildSearchQuery() previously appended, regardless of
    // which vendor option was active.
    var VENDOR_CLAUSE_REGEX = /\(?\s*-?vendor:(?:"|&quot;)[^"&]*(?:"|&quot;)(?:\s+OR\s+-?vendor:(?:"|&quot;)[^"&]*(?:"|&quot;))*\s*\)?/gi;

    function storageAvailable() {
        try {
            var key = '__predictive_search_test__';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
            return true;
        } catch (error) {
            return false;
        }
    }

    var canUseStorage = storageAvailable();

    function isValidVendorFilter(value) {
        return VENDOR_OPTIONS.some(function (option) {
            return option.value === value;
        });
    }

    function getVendorOption(value) {
        var found = VENDOR_OPTIONS.filter(function (option) {
            return option.value === value;
        })[0];
        return found || VENDOR_OPTIONS[0];
    }

    function getStoredVendorFilter() {
        if (!canUseStorage) return DEFAULT_VENDOR_FILTER;
        var stored = window.localStorage.getItem(STORAGE_KEY);
        return isValidVendorFilter(stored) ? stored : DEFAULT_VENDOR_FILTER;
    }

    function setStoredVendorFilter(value) {
        var normalized = isValidVendorFilter(value) ? value : DEFAULT_VENDOR_FILTER;
        if (canUseStorage) window.localStorage.setItem(STORAGE_KEY, normalized);
        return normalized;
    }

    function stripVendorQuery(query) {
        return (query || '')
            .replace(VENDOR_CLAUSE_REGEX, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function normalizeVendor(value) {
        return String(value || '').trim().toLowerCase();
    }

    function buildVendorFilterClause(option) {
        if (!option || !option.vendors || !option.vendors.length) return '';
        if (option.vendors.length === 1) {
            return 'vendor:"' + option.vendors[0] + '"';
        }
        return '(' + option.vendors.map(function (vendor) {
            return 'vendor:"' + vendor + '"';
        }).join(' OR ') + ')';
    }

    function buildSearchQuery(query, vendorFilterValue) {
        var cleanQuery = stripVendorQuery(query);
        var option = getVendorOption(vendorFilterValue);
        var clause = buildVendorFilterClause(option);
        if (!clause) return cleanQuery;
        return (cleanQuery + ' ' + clause).trim();
    }

    function productMatchesVendorFilter(product, vendorFilterValue) {
        var option = getVendorOption(vendorFilterValue);

        // "Entire Site" — no vendor should be excluded.
        if (!option.vendors || !option.vendors.length) {
            if (DEBUG_VENDOR_FILTER && product) {
                console.log('Selected Vendor:', option.label);
                console.log('Product Vendor:', product.vendor);
                console.log('Vendor Filter Match: true (entire site)');
            }
            return true;
        }

        if (!product) return false;

        var productVendor = normalizeVendor(product.vendor);
        var matches = option.vendors.some(function (vendor) {
            return normalizeVendor(vendor) === productVendor;
        });

        if (DEBUG_VENDOR_FILTER) {
            console.log('Selected Vendor:', option.label);
            console.log('Product Vendor:', product.vendor);
            console.log('Vendor Filter Match:', matches);
        }

        return matches;
    }

    function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[character];
        });
    }

    function formatMoney(cents) {
        if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
            return theme.Shopify.formatMoney(cents || 0, moneyFormat);
        }
        return '$' + ((cents || 0) / 100).toFixed(2);
    }

    function getSizedImageUrl(image) {
        var src = typeof image === 'string' ? image : image && image.url;
        if (!src) return '';
        if (window.slate && slate.Image && typeof slate.Image.getSizedImageUrl === 'function') {
            return slate.Image.getSizedImageUrl(src, '100x100_crop_center');
        }
        return src;
    }

    function syncVendorControls(value) {
        var normalized = setStoredVendorFilter(value);
        document.querySelectorAll('[data-vendor-filter-select]').forEach(function (select) {
            select.value = normalized;
        });
        document.querySelectorAll('[data-vendor-filter-input]').forEach(function (input) {
            input.value = normalized;
        });
        return normalized;
    }

    function getSearchUrl(form, query, vendorFilter) {
        var params = new URLSearchParams(new FormData(form));
        params.set('q', buildSearchQuery(query, vendorFilter));
        params.delete('vendor_filter');
        return form.action + '?' + params.toString();
    }

    function prepareSearchForm(form, input) {
        if (!form || !input) return;
        var cleanQuery = stripVendorQuery(input.value);
        var vendorFilter = getStoredVendorFilter();
        var queryInput = form.querySelector('[data-predictive-search-query-input]');

        if (!queryInput) {
            queryInput = document.createElement('input');
            queryInput.type = 'hidden';
            queryInput.name = 'q';
            queryInput.setAttribute('data-predictive-search-query-input', '');
            form.appendChild(queryInput);
        }

        queryInput.value = buildSearchQuery(cleanQuery, vendorFilter);
        input.removeAttribute('name');

        var vendorInput = form.querySelector('[data-vendor-filter-input]');
        if (vendorInput) {
            vendorInput.value = vendorFilter;
            vendorInput.disabled = true;
        }
    }

    function submitSearchForm(form, input) {
        prepareSearchForm(form, input);
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            form.submit();
        }
    }

    function createState(root) {
        return {
            root: root,
            form: root.querySelector('[data-predictive-search-form]'),
            input: root.querySelector('[data-predictive-search-input]'),
            results: root.querySelector('[data-predictive-search-results]'),
            abortController: null,
            debounceTimer: null,
            activeIndex: -1
        };
    }

    function setExpanded(state, expanded) {
        state.input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        state.root.classList.toggle('search-bar--has-results', expanded);
    }

    function getResultItems(state) {
        return Array.prototype.slice.call(state.results.querySelectorAll('[data-predictive-result-item]'));
    }

    function setActiveResult(state, index) {
        var items = getResultItems(state);
        state.activeIndex = index;
        items.forEach(function (item, itemIndex) {
            var active = itemIndex === index;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            if (active) {
                state.input.setAttribute('aria-activedescendant', item.id);
                item.scrollIntoView({ block: 'nearest' });
            }
        });
        if (index < 0) state.input.removeAttribute('aria-activedescendant');
    }

    function hideResults(state) {
        if (!state.results) return;
        state.results.innerHTML = '';
        state.root.classList.remove('search-bar--loading-results');
        setExpanded(state, false);
        setActiveResult(state, -1);
    }

    function renderStatus(state, message, modifier) {
        state.results.innerHTML = '<div class="search-result search-result--' + modifier + '">' + escapeHtml(message) + '</div>';
        state.root.classList.remove('search-bar--loading-results');
        setExpanded(state, true);
    }

    function sectionTitle(title) {
        return '<div class="predictive-search__section-title">' + escapeHtml(title) + '</div>';
    }

    function resultAttributes(state, index) {
        return ' id="' + state.input.id + '-result-' + index + '" role="option" aria-selected="false" data-predictive-result-item';
    }

    function renderProduct(product, state, index) {
        var image = getSizedImageUrl(product.image || product.featured_image);
        var thumb = image
            ? '<img role="presentation" alt="" src="' + escapeHtml(image) + '">'
            : '<span class="search-result__char">' + escapeHtml((product.title || '?').charAt(0)) + '</span>';
        return [
            '<a class="search-result search-result--product"' + resultAttributes(state, index) + ' href="' + escapeHtml(product.url) + '">',
            '<span class="search-result__image">' + thumb + '</span>',
            '<span class="search-result__title search-result__title--product">',
            '<span class="search-result__product">' + escapeHtml(product.title) + '</span>',
            // '<span class="search-result__vendor">' + escapeHtml(product.vendor || '') + '</span>',
            '&nbsp;<span class="search-result__price product-price">' + formatMoney(product.price_min) + '</span>',
            '</span>',
            '</a>'
        ].join('');
    }

    function renderSimpleResult(result, state, index) {
        return [
            '<a class="search-result" ' + resultAttributes(state, index) + ' href="' + escapeHtml(result.url) + '">',
            '<span class="search-result__image"><span class="search-result__char">' + escapeHtml((result.title || '?').charAt(0)) + '</span></span>',
            '<span class="search-result__title">' + escapeHtml(result.title) + '</span>',
            '</a>'
        ].join('');
    }

    function renderResults(state, response, query, vendorFilter) {
        var results = response && response.resources && response.resources.results ? response.resources.results : {};
        var products = results.products || [];
        var collections = results.collections || [];
        var pages = results.pages || [];
        var articles = results.articles || [];
        var html = '';
        var index = 0;
        var option = getVendorOption(vendorFilter);

        if (DEBUG_VENDOR_FILTER) {
            console.log('Selected Vendor:', option.label);
            console.log('Predictive Search Response Data:', response);
        }

        products = products.filter(function (product) {
            return productMatchesVendorFilter(product, vendorFilter);
        });

        if (products.length) {
            html += sectionTitle('Products') + products.map(function (product) {
                return renderProduct(product, state, index++);
            }).join('');
        }

        if (collections.length) {
            html += sectionTitle('Collections') + collections.map(function (collection) {
                return renderSimpleResult(collection, state, index++);
            }).join('');
        }

        if (pages.length) {
            html += sectionTitle('Pages') + pages.map(function (page) {
                return renderSimpleResult(page, state, index++);
            }).join('');
        }

        if (articles.length) {
            html += sectionTitle('Articles') + articles.map(function (article) {
                return renderSimpleResult(article, state, index++);
            }).join('');
        }

        if (!html) {
            renderStatus(state, (window.theme && theme.strings && theme.strings.searchNoResults) || 'No results found', 'empty');
            return;
        }

        html = '<div class="search-results__results">' + html + '</div>';
        html += '<a class="search-result search-result--more" href="' + escapeHtml(getSearchUrl(state.form, query, vendorFilter)) + '">' + escapeHtml((window.theme && theme.strings && theme.strings.searchMoreResults) || 'View all results') + '</a>';

        state.results.innerHTML = html;
        state.root.classList.remove('search-bar--loading-results');
        setExpanded(state, true);
        setActiveResult(state, -1);
    }

    function fetchResults(state) {
        var query = stripVendorQuery(state.input.value);
        var vendorFilter = getStoredVendorFilter();

        if (query.length < MIN_QUERY_LENGTH) {
            hideResults(state);
            return;
        }

        if (state.abortController) state.abortController.abort();
        state.abortController = new AbortController();
        state.root.classList.add('search-bar--loading-results');
        renderStatus(state, (window.theme && theme.strings && theme.strings.searchLoading) || 'Loading...', 'loading');

        var params = new URLSearchParams();
        params.set('q', buildSearchQuery(query, vendorFilter));
        params.set('resources[type]', 'product,collection,page,article');
        params.set('resources[limit]', '5');
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');

        fetch((window.theme && theme.routes ? theme.routes.search_url : '/search') + '/suggest.json?' + params.toString(), {
            signal: state.abortController.signal,
            headers: { Accept: 'application/json' }
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Predictive search request failed');
                return response.json();
            })
            .then(function (data) {
                renderResults(state, data, query, vendorFilter);
            })
            .catch(function (error) {
                if (error.name === 'AbortError') return;
                renderStatus(state, 'Search is temporarily unavailable. Please try again.', 'empty');
            })
            .finally(function () {
                state.abortController = null;
            });
    }

    function bindPredictiveSearch(root) {
        var state = createState(root);
        if (!state.form || !state.input || !state.results) return;

        state.input.value = stripVendorQuery(state.input.value);

        state.input.addEventListener('input', function () {
            window.clearTimeout(state.debounceTimer);
            state.debounceTimer = window.setTimeout(function () {
                fetchResults(state);
            }, DEBOUNCE_MS);
        });

        state.input.addEventListener('keydown', function (event) {
            var items = getResultItems(state);
            if (event.key === 'Enter' && (!items.length || state.activeIndex === -1)) {
                event.preventDefault();
                submitSearchForm(state.form, state.input);
                return;
            }

            if (!items.length) return;

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setActiveResult(state, state.activeIndex >= items.length - 1 ? 0 : state.activeIndex + 1);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                setActiveResult(state, state.activeIndex <= 0 ? items.length - 1 : state.activeIndex - 1);
            } else if (event.key === 'Enter' && state.activeIndex > -1) {
                event.preventDefault();
                items[state.activeIndex].click();
            } else if (event.key === 'Escape') {
                hideResults(state);
            }
        });

        state.form.addEventListener('submit', function () {
            prepareSearchForm(state.form, state.input);
        });

        root.addEventListener('focusout', function () {
            window.setTimeout(function () {
                if (!root.contains(document.activeElement)) hideResults(state);
            }, 150);
        });
    }

    function bindVendorControls() {
        syncVendorControls(getStoredVendorFilter());

        document.addEventListener('change', function (event) {
            if (!event.target.matches('[data-vendor-filter-select]')) return;
            var selected = syncVendorControls(event.target.value);
            document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
                var input = root.querySelector('[data-predictive-search-input]');
                if (input && stripVendorQuery(input.value).length >= MIN_QUERY_LENGTH) {
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            var pageForm = event.target.closest('[data-search-page-form]');
            if (pageForm) {
                var pageInput = pageForm.querySelector('[data-search-page-input]');
                if (pageInput) pageInput.value = pageInput.value || '1';
                pageForm.requestSubmit ? pageForm.requestSubmit() : pageForm.submit();
            }
        });
    }

    function bindSearchPage() {
        var form = document.querySelector('.search-page-form');
        if (!form) return;
        var input = form.querySelector('input[name="q"]');
        var params = new URLSearchParams(window.location.search);

        if (input) input.value = stripVendorQuery(input.value || params.get('q') || '');

        form.addEventListener('submit', function () {
            if (!input) return;
            var vendorFilter = getStoredVendorFilter();
            var queryInput = form.querySelector('[data-predictive-search-query-input]');
            if (!queryInput) {
                queryInput = document.createElement('input');
                queryInput.type = 'hidden';
                queryInput.name = 'q';
                queryInput.setAttribute('data-predictive-search-query-input', '');
                form.appendChild(queryInput);
            }
            queryInput.value = buildSearchQuery(input.value, vendorFilter);
            input.removeAttribute('name');
        });

        if (params.has('vendor_filter')) {
            params.delete('vendor_filter');
            window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        bindVendorControls();
        document.querySelectorAll('[data-predictive-search]').forEach(bindPredictiveSearch);
        bindSearchPage();
    });
})();